import { render, staticRenderFns } from "./TextBlockConfigView.vue?vue&type=template&id=d4d28fca"
import script from "./TextBlockConfigView.vue?vue&type=script&lang=js"
export * from "./TextBlockConfigView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports